function initProductCardVariants() {
  const productCards = document.querySelectorAll(".product-card");
  if (!productCards?.length) return;

  productCards.forEach((card) => {
    if (card.dataset.initialized) return;
    card.dataset.initialized = "true";

    const variantButtons = card.querySelectorAll(".pc-vars-var-btn");
    const variantIdInput = card.querySelector(
      'form[is="product-form"] input[name="id"]'
    );
    const ratingWrapper = card.querySelector(".card-product-ratings-wrapper");

    if (!variantButtons?.length || !variantIdInput || !ratingWrapper) return;

    const firstVariantButton = variantButtons[0];
    if (firstVariantButton) {
      firstVariantButton.click();
    }

    variantButtons.forEach((button) => {
      if (!button) return;

      button.addEventListener("click", (e) => {
        try {
          e.preventDefault();

          const variantId = button.getAttribute("data-var-id");
          if (!variantId) {
            console.error("Variant ID not found on button");
            return;
          }

          const variantAvailable = button.getAttribute("data-var-available");
          const productCardAtcBtn = card.querySelector(
            'form[is="product-form"] button[type="submit"]'
          );

          if (variantAvailable === "false" && productCardAtcBtn) {
            productCardAtcBtn.setAttribute("disabled", "true");
            productCardAtcBtn.style.opacity = "0.5";
            productCardAtcBtn.style.cursor = "not-allowed";
            productCardAtcBtn.querySelector(
              ".product-card-view-options-btn-inner"
            ).textContent = "Sold Out";
          } else if (productCardAtcBtn) {
            productCardAtcBtn.removeAttribute("disabled");
            productCardAtcBtn.style.opacity = "1";
            productCardAtcBtn.style.cursor = "pointer";
            productCardAtcBtn.querySelector(
              ".product-card-view-options-btn-inner"
            ).textContent = "Add to cart";
          }

          card
            .querySelectorAll(".pc-vars-var-btn")
            .forEach((btn) => btn.classList.remove("active"));
          button.classList.add("active");

          ratingWrapper.querySelectorAll(".price-list").forEach((priceList) => {
            priceList.classList.toggle(
              "active",
              priceList.getAttribute("data-var-id") === variantId
            );
          });

          variantIdInput.value = variantId;
        } catch (error) {
          console.error("Error handling variant selection:", error);
        }
      });
    });
  });
}

window.handleVariantSelection = function (variantId, variantAvailable, card) {
  try {
    if (!variantId) {
      console.error("Variant ID not found");
      return;
    }

    // Update variant ID input
    const variantIdInput = card.querySelector(
      'form[is="product-form"] input[name="id"]'
    );
    if (variantIdInput) {
      variantIdInput.value = variantId;
    }

    // Update button states
    card.querySelectorAll(".pc-vars-var-btn").forEach((btn) => {
      btn.classList.remove("active");
      if (btn.getAttribute("data-var-id") === variantId) {
        btn.classList.add("active");
      }
    });

    // Update price lists
    const ratingWrapper = card.querySelector(".card-product-ratings-wrapper");
    if (ratingWrapper) {
      ratingWrapper.querySelectorAll(".price-list").forEach((priceList) => {
        priceList.classList.toggle(
          "active",
          priceList.getAttribute("data-var-id") === variantId
        );
      });
    }

    // Update ATC button state
    const productCardAtcBtn = card.querySelector(
      'form[is="product-form"] button[type="submit"]'
    );
    if (productCardAtcBtn) {
      if (variantAvailable === "false") {
        productCardAtcBtn.setAttribute("disabled", "true");
        productCardAtcBtn.style.opacity = "0.5";
        productCardAtcBtn.style.cursor = "not-allowed";
        productCardAtcBtn.querySelector(
          ".product-card-view-options-btn-inner"
        ).textContent = "Sold Out";
      } else {
        productCardAtcBtn.removeAttribute("disabled");
        productCardAtcBtn.style.opacity = "1";
        productCardAtcBtn.style.cursor = "pointer";
        productCardAtcBtn.querySelector(
          ".product-card-view-options-btn-inner"
        ).textContent = "Add to cart";
      }
    }
  } catch (error) {
    console.error("Error handling variant selection:", error);
  }
};
